import { useTranslation } from 'react-i18next'

import { EntityActionTypeSelect } from '../../Entity'
import { FieldStackedLabel } from '../../Field'
import { FormFieldSelectNG } from '../../Form'
import { FormikField } from '../FormikField'

import { getFormikEntityActionTypeFieldInfo } from './FormikEntityActionTypeField.utils'

import * as styles from './FormikEntityActionTypeField.module.css'

function FormikEntityActionTypeField({
  fieldComponentProps,
  options,
  ...restProps
}) {
  const { t } = useTranslation()

  const typeSelectInfoTooltip = (
    <div className={styles.tooltip}>
      {getFormikEntityActionTypeFieldInfo(options).map(tooltip => (
        <div key={tooltip}>{t(tooltip)}</div>
      ))}
    </div>
  )

  return (
    <FormikField
      {...restProps}
      Component={FormFieldSelectNG}
      Field={FieldStackedLabel}
      Select={EntityActionTypeSelect}
      fieldComponentProps={{
        ...fieldComponentProps,
        info: typeSelectInfoTooltip,
        label: t('Common.FormikEntityActionTypeSelectFieldLabelKey'),
      }}
      options={options}
    />
  )
}

export default FormikEntityActionTypeField
